import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui's standard class-merging helper. Combines clsx (conditional
 * class names) with tailwind-merge (dedupes conflicting Tailwind classes).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
